function getSuggestionValue(suggestion) {
    if (suggestion) {
        var div = document.createElement("div");
        div.innerHTML = suggestion;
        return div.innerText;
    }
    
    return "";
}

function renderSuggestion(suggestion) {
    return (
        <span dangerouslySetInnerHTML={{ __html: suggestion }}></span>
    );
}

import React from "react";
import _ from 'lodash';
import axios from 'axios';
import Autosuggest from "./ReactAutosuggest/Autosuggest";

export default class AutoSuggester extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.searchLabel,
            suggestions: [],
            isLoading: false
        };

        this.lastRequestId = null;
    }

    componentDidMount() {
        this.setState({
            value: this.props.searchLabel,
        });
    }

    loadSuggestions(value) {
        // Cancel the previous request
        if (this.lastRequestId !== null) {
            clearTimeout(this.lastRequestId);
        }

        this.setState({
            isLoading: true
        });

        axios({
            method: 'post',
            url: "/api/azurecognitivesuggest/",
            data: {
                term: value,
                siteName: this.props.siteName
            }
        }).then((res) => {
            if (res.data && res.data.length > 0) {
                this.setState({
                    isLoading: false,
                    suggestions: res.data
                });
            }
            else {
                this.setState({
                    isLoading: false,
                    suggestions: []
                });
            }
        }).catch((err) => {
            this.setState({
                isLoading: false,
                suggestions: []
            });
        });
    }

    onChange = (event, { newValue, method }) => {
        this.setState({
            value: newValue
        }, function () {
            this.props.onChange(newValue, method);
        });
    };

    onKeyPress = (event) => {
        this.props.onKeyPress(event);
    };

    onSuggestionsFetchRequested = ({ value }) => {
        this.loadSuggestions(value);
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    shouldRenderSuggestions(value, reason) {
        return value.trim().length > 2;
    }

    renderInputComponent = inputProps => (
        <label className="custom" htmlFor={"o" + this.props.labelId + "search"} aria-label="Search">
                <input {...inputProps} />
            </label>
    );

    render() {
        const { value, suggestions, isLoading } = this.state;
        const { searchLabel, idSuggester, labelId, searchPlaceHolder } = this.props;
        const inputProps = {
            placeholder: searchPlaceHolder ,
            name: "o" + labelId + "search",
            value: this.props.searchLabel,
            onChange: this.onChange,
            onKeyPress: this.onKeyPress,
            id: "o" + labelId + "search",
        };

        return (
            <React.Fragment>
                <Autosuggest
                    suggestions={suggestions}
                    onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                    onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                    getSuggestionValue={getSuggestionValue}
                    renderSuggestion={renderSuggestion}
                    shouldRenderSuggestions={this.shouldRenderSuggestions}
                    inputProps={inputProps}
                    id={idSuggester}
                    renderInputComponent={this.renderInputComponent}
                />
                {!isLoading && !this.props.quickSearchLoading &&
                    <button type="submit" className="btn" onClick={() => this.props.onSearch(this.state.value)} aria-label="Submit">
                        <i className="fa-solid fa-magnifying-glass"></i>
                    </button>
                }
                {(isLoading || this.props.quickSearchLoading) &&
                    <div className="loading-indicator">
                        <i className="fas fa-spinner fa-spin"></i>
                    </div>
                    }
            </React.Fragment>
        );
    }
}